import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { MenuRegistryService } from './core/services/menu-registry.service';
import { BiologicalSamplingModule } from './domains/biological-sampling/biological-sampling.module';
import { FleetManagementModule } from './domains/fleet-management/fleet-management.module';
import { GraphsModule } from './domains/graphs/graphs-module';
import { LandingInspectionModule } from './domains/landing-inspection/landing-inspection.module';
import { SettingsModule } from './domains/settings/settings-module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class AppComponent {
  constructor(
    private readonly menuRegistry: MenuRegistryService,
    private readonly router: Router,
    // Inject modules to trigger their constructors for menu registration
    private readonly landingInspectionModule: LandingInspectionModule,
    private readonly biologicalSamplingModule: BiologicalSamplingModule,
    private readonly fleetManagementModule: FleetManagementModule,
    private readonly graphsModule: GraphsModule,
    private readonly settingsModule: SettingsModule
  ) {}
}
